"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrappedNFTFactory = void 0;
var WrappedNFTFactoryAbi_json_1 = __importDefault(require("./WrappedNFTFactoryAbi.json"));
exports.WrappedNFTFactory = WrappedNFTFactoryAbi_json_1.default;
